// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"72":"dc620ba4abb297e4","550":"1f5e71f6caabff0a","636":"04d4239bc9fd40e0"}[chunkId] + ".js";
};